import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../locales/translations';

export function useStudentRemovalRequestTranslation() {
  const translation = useTranslation(
    TranslationsKeys.STUDENT_MANAGEMENT_STUDENT_REMOVAL_REQUEST_VIEW,
  );

  return translation;
}
